
import { toString, Record, Union } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { lambda_type, unit_type, record_type, union_type, list_type, tuple_type, string_type, option_type, class_type, bool_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { FormState__startLoading, FormState_get_empty, FormState_$reflection, SetId_$reflection, ClientApiResponse$1_$reflection } from "../../Shared/Shared.js";
import { DocumentInformation as DocumentInformation_1, ToolConfirmReminderDto, ToolConfirmReminderDto_$reflection } from "../../Shared/Tool.js";
import { DataTransfer_SetReminder_$reflection } from "../../Shared/Set.js";
import { Cmd_ofEffect, Cmd_batch, Cmd_none } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { now, timeOfDay, add } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Date.js";
import { Cmd_OfPromise_either } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { fetchWithDecoder, addPrefix } from "../../CommunicationV2.js";
import { Types_RequestProperties } from "../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { head, singleton, ofArray } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { confirmReminderCmd } from "../../Requests/Set.js";
import { Cmd_successToast, Cmd_errorToast } from "../../Components/Toast.js";
import { unwrap, defaultArg } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { nativeType, useDrop } from "../../Bindings/Fable.ReactDnD.js";
import { item, equalsWith } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Array.js";
import { createObj, defaultOf, equals } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { reactApi, reactElement } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { join } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { InformationAlert } from "../../Components/Alert.js";
import { empty, singleton as singleton_1, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { TextValue } from "../../Components/Text.js";
import { Checkbox } from "../../Components/Checkbox.js";
import { defaultOf as defaultOf_1 } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { DatePicker } from "../../Components/DatePicker.js";
import { TextArea } from "../../Components/TextArea.js";
import { TextButton } from "../../Components/Button.js";
import Upload_File from "../../../public/assets/icons/Upload_File.svg";
import { Input } from "../../Components/Input.js";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { Dialog } from "../../Components/Dialog.js";

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SetLastInspectionDate", "SetDate", "SetCreateNewDate", "SetConfirmationComment", "SetIsVisibleForUserRole", "SetName", "SetDescription", "SelectFile", "ConfirmToolReminder", "ToolReminderConfirmed", "SaveConfirmReminder", "DocUploaded", "FetchError"];
    }
}

function Msg_$reflection() {
    return union_type("Sets.Dialog.ConfirmReminderDialog.Msg", [], Msg, () => [[["Item", bool_type]], [["Item", option_type(class_type("System.DateTime"))]], [["Item", bool_type]], [["Item", string_type]], [], [["Item", string_type]], [["Item", string_type]], [["Item", option_type(class_type("Browser.Types.File", undefined))]], [], [["Item", string_type]], [], [["Item", ClientApiResponse$1_$reflection(list_type(tuple_type(string_type, string_type)))]], [["Item", class_type("System.Exception")]]]);
}

export class DocumentValue extends Record {
    constructor(Name, Description, IsVisibleForUserRole) {
        super();
        this.Name = Name;
        this.Description = Description;
        this.IsVisibleForUserRole = IsVisibleForUserRole;
    }
}

export function DocumentValue_$reflection() {
    return record_type("Sets.Dialog.ConfirmReminderDialog.DocumentValue", [], DocumentValue, () => [["Name", string_type], ["Description", string_type], ["IsVisibleForUserRole", bool_type]]);
}

export class State extends Record {
    constructor(SetId, FormState, SuccessCallback, Dto, OnClose, IsNormalReminder, IsTitleInvalid, Reminder, SelectedFile, DocumentValue) {
        super();
        this.SetId = SetId;
        this.FormState = FormState;
        this.SuccessCallback = SuccessCallback;
        this.Dto = Dto;
        this.OnClose = OnClose;
        this.IsNormalReminder = IsNormalReminder;
        this.IsTitleInvalid = IsTitleInvalid;
        this.Reminder = Reminder;
        this.SelectedFile = SelectedFile;
        this.DocumentValue = DocumentValue;
    }
}

export function State_$reflection() {
    return record_type("Sets.Dialog.ConfirmReminderDialog.State", [], State, () => [["SetId", SetId_$reflection()], ["FormState", FormState_$reflection()], ["SuccessCallback", lambda_type(bool_type, unit_type)], ["Dto", ToolConfirmReminderDto_$reflection()], ["OnClose", lambda_type(unit_type, unit_type)], ["IsNormalReminder", bool_type], ["IsTitleInvalid", bool_type], ["Reminder", DataTransfer_SetReminder_$reflection()], ["SelectedFile", option_type(class_type("Browser.Types.File", undefined))], ["DocumentValue", option_type(DocumentValue_$reflection())]]);
}

function init(setId, successCallback, reminder, onClose) {
    let IsNormalReminder;
    return [(IsNormalReminder = (reminder.Interval == null), new State(setId, FormState_get_empty(), successCallback, new ToolConfirmReminderDto(!reminder.IsConfirmed, reminder.Id, reminder.Interval != null, false, undefined, undefined, "", undefined), onClose, IsNormalReminder, false, reminder, undefined, undefined)), Cmd_none()];
}

function update(msg, state) {
    let bind$0040_1, bind$0040_2, bind$0040_3, bind$0040_4, bind$0040;
    switch (msg.tag) {
        case 1: {
            const value_1 = msg.fields[0];
            if (value_1 == null) {
                return [state, Cmd_none()];
            }
            else {
                return [new State(state.SetId, state.FormState, state.SuccessCallback, (bind$0040_1 = state.Dto, new ToolConfirmReminderDto(bind$0040_1.IsConfirmed, bind$0040_1.ReminderId, bind$0040_1.CreateNewDate, bind$0040_1.SetLastInspectionDate, add(value_1, timeOfDay(now())), bind$0040_1.NextInspectionDate, bind$0040_1.ConfirmationComment, bind$0040_1.DocumentInformation)), state.OnClose, state.IsNormalReminder, state.IsTitleInvalid, state.Reminder, state.SelectedFile, state.DocumentValue), Cmd_none()];
            }
        }
        case 2:
            return [new State(state.SetId, state.FormState, state.SuccessCallback, (bind$0040_2 = state.Dto, new ToolConfirmReminderDto(bind$0040_2.IsConfirmed, bind$0040_2.ReminderId, msg.fields[0], bind$0040_2.SetLastInspectionDate, bind$0040_2.LastInspectionDate, bind$0040_2.NextInspectionDate, bind$0040_2.ConfirmationComment, bind$0040_2.DocumentInformation)), state.OnClose, state.IsNormalReminder, state.IsTitleInvalid, state.Reminder, state.SelectedFile, state.DocumentValue), Cmd_none()];
        case 3:
            return [new State(state.SetId, state.FormState, state.SuccessCallback, (bind$0040_3 = state.Dto, new ToolConfirmReminderDto(bind$0040_3.IsConfirmed, bind$0040_3.ReminderId, bind$0040_3.CreateNewDate, bind$0040_3.SetLastInspectionDate, bind$0040_3.LastInspectionDate, bind$0040_3.NextInspectionDate, msg.fields[0], bind$0040_3.DocumentInformation)), state.OnClose, state.IsNormalReminder, state.IsTitleInvalid, state.Reminder, state.SelectedFile, state.DocumentValue), Cmd_none()];
        case 8: {
            const matchValue = state.SelectedFile;
            const matchValue_1 = state.DocumentValue;
            let matchResult, docValue, file;
            if (matchValue == null) {
                matchResult = 1;
            }
            else if (matchValue_1 == null) {
                matchResult = 1;
            }
            else {
                matchResult = 0;
                docValue = matchValue_1;
                file = matchValue;
            }
            switch (matchResult) {
                case 0: {
                    const formData = new FormData();
                    formData.append(file.name, file);
                    formData.append("Name", docValue.Name);
                    formData.append("Description", docValue.Description);
                    formData.append("IsVisibleForUserRole", toString(docValue.IsVisibleForUserRole));
                    return [new State(state.SetId, FormState__startLoading(state.FormState), state.SuccessCallback, state.Dto, state.OnClose, state.IsNormalReminder, state.IsTitleInvalid, state.Reminder, state.SelectedFile, state.DocumentValue), Cmd_OfPromise_either((tupledArg) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                        let url_2;
                        return ((url_2 = addPrefix(tupledArg[0]), (refreshOn) => fetchWithDecoder(url_2, ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [tupledArg[1]])]), undefined, (response) => {
                            const pr = response.arrayBuffer();
                            return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), list_type(tuple_type(string_type, string_type))));
                        }, refreshOn)))(true);
                    })), ["/api/files/documents", formData], (Item) => (new Msg(11, [Item])), (Item_1) => (new Msg(12, [Item_1])))];
                }
                default:
                    return [new State(state.SetId, FormState__startLoading(state.FormState), state.SuccessCallback, state.Dto, state.OnClose, state.IsNormalReminder, state.IsTitleInvalid, state.Reminder, state.SelectedFile, state.DocumentValue), singleton((dispatch) => {
                        dispatch(new Msg(10, []));
                    })];
            }
        }
        case 10:
            return [new State(state.SetId, FormState__startLoading(state.FormState), state.SuccessCallback, state.Dto, state.OnClose, state.IsNormalReminder, state.IsTitleInvalid, state.Reminder, state.SelectedFile, state.DocumentValue), confirmReminderCmd(state.SetId, state.Dto, (Item_2) => (new Msg(9, [Item_2])), (Item_3) => (new Msg(12, [Item_3])))];
        case 9:
            if (msg.fields[0] === "notAuthorized") {
                return [new State(state.SetId, FormState_get_empty(), state.SuccessCallback, state.Dto, state.OnClose, state.IsNormalReminder, state.IsTitleInvalid, state.Reminder, state.SelectedFile, state.DocumentValue), Cmd_errorToast("validation_error.not_authorized")];
            }
            else {
                return [new State(state.SetId, FormState_get_empty(), state.SuccessCallback, state.Dto, state.OnClose, state.IsNormalReminder, state.IsTitleInvalid, state.Reminder, state.SelectedFile, state.DocumentValue), Cmd_batch(ofArray([Cmd_ofEffect((_arg) => {
                    state.SuccessCallback(state.SelectedFile != null);
                }), Cmd_ofEffect((_arg_1) => {
                    state.OnClose();
                }), Cmd_successToast("tool.dialog_mark_appointment_as_done_success")]))];
            }
        case 11: {
            const response_2 = msg.fields[0];
            if (response_2.tag === 1) {
                return [state, Cmd_errorToast("validation.toast")];
            }
            else {
                const patternInput = head(response_2.fields[0]);
                const documentValue = defaultArg(state.DocumentValue, new DocumentValue("", "", false));
                return [new State(state.SetId, state.FormState, state.SuccessCallback, (bind$0040_4 = state.Dto, new ToolConfirmReminderDto(bind$0040_4.IsConfirmed, bind$0040_4.ReminderId, bind$0040_4.CreateNewDate, bind$0040_4.SetLastInspectionDate, bind$0040_4.LastInspectionDate, bind$0040_4.NextInspectionDate, bind$0040_4.ConfirmationComment, new DocumentInformation_1(documentValue.Name, documentValue.Description, documentValue.IsVisibleForUserRole, patternInput[0], patternInput[1]))), state.OnClose, state.IsNormalReminder, state.IsTitleInvalid, state.Reminder, state.SelectedFile, state.DocumentValue), singleton((dispatch_1) => {
                    dispatch_1(new Msg(10, []));
                })];
            }
        }
        case 4: {
            const matchValue_3 = state.DocumentValue;
            if (matchValue_3 == null) {
                return [state, Cmd_none()];
            }
            else {
                const docValue_1 = matchValue_3;
                return [new State(state.SetId, state.FormState, state.SuccessCallback, state.Dto, state.OnClose, state.IsNormalReminder, state.IsTitleInvalid, state.Reminder, state.SelectedFile, new DocumentValue(docValue_1.Name, docValue_1.Description, !docValue_1.IsVisibleForUserRole)), Cmd_none()];
            }
        }
        case 5: {
            const matchValue_4 = state.DocumentValue;
            if (matchValue_4 == null) {
                return [state, Cmd_none()];
            }
            else {
                const docValue_2 = matchValue_4;
                return [new State(state.SetId, state.FormState, state.SuccessCallback, state.Dto, state.OnClose, state.IsNormalReminder, state.IsTitleInvalid, state.Reminder, state.SelectedFile, new DocumentValue(msg.fields[0], docValue_2.Description, docValue_2.IsVisibleForUserRole)), Cmd_none()];
            }
        }
        case 6: {
            const matchValue_5 = state.DocumentValue;
            if (matchValue_5 == null) {
                return [state, Cmd_none()];
            }
            else {
                const docValue_3 = matchValue_5;
                return [new State(state.SetId, state.FormState, state.SuccessCallback, state.Dto, state.OnClose, state.IsNormalReminder, state.IsTitleInvalid, state.Reminder, state.SelectedFile, new DocumentValue(docValue_3.Name, msg.fields[0], docValue_3.IsVisibleForUserRole)), Cmd_none()];
            }
        }
        case 7: {
            const file_1 = msg.fields[0];
            return [new State(state.SetId, state.FormState, state.SuccessCallback, state.Dto, state.OnClose, state.IsNormalReminder, state.IsTitleInvalid, state.Reminder, file_1, (file_1 == null) ? undefined : (new DocumentValue("", "", true))), Cmd_none()];
        }
        case 12:
            return [new State(state.SetId, FormState_get_empty(), state.SuccessCallback, state.Dto, state.OnClose, state.IsNormalReminder, state.IsTitleInvalid, state.Reminder, state.SelectedFile, state.DocumentValue), Cmd_none()];
        default:
            return [new State(state.SetId, state.FormState, state.SuccessCallback, (bind$0040 = state.Dto, new ToolConfirmReminderDto(bind$0040.IsConfirmed, bind$0040.ReminderId, bind$0040.CreateNewDate, msg.fields[0], bind$0040.LastInspectionDate, bind$0040.NextInspectionDate, bind$0040.ConfirmationComment, bind$0040.DocumentInformation)), state.OnClose, state.IsNormalReminder, state.IsTitleInvalid, state.Reminder, state.SelectedFile, state.DocumentValue), Cmd_none()];
    }
}

function DialogBody(props) {
    let elems, elems_7;
    const t = useTranslation()[0];
    const patternInput_1 = useDrop({
        accept: nativeType.FILE,
        collect: (monitor) => {
            const isOver = monitor.isOver();
            return {
                canDrop: monitor.canDrop(),
                isOver: isOver,
            };
        },
        drop: (draggedFile) => {
            let testExpr, testExpr_1;
            const matchValue = draggedFile.files;
            if (matchValue == null) {
            }
            else if ((testExpr = matchValue, !equalsWith(equals, testExpr, defaultOf()) && (testExpr.length === 0))) {
            }
            else if ((testExpr_1 = matchValue, !equalsWith(equals, testExpr_1, defaultOf()) && (testExpr_1.length === 1))) {
                const file = item(0, matchValue);
                props.OnSelectFile(file);
            }
        },
    });
    const dropData = patternInput_1[0];
    const isCreateNextReminderCheckboxVisible = !props.State.Reminder.IsConfirmed && (props.State.Reminder.Interval != null);
    const labelText = props.State.Reminder.IsConfirmed ? t("tool.dialog_mark_appointment_as_not_done") : t("tool.dialog_mark_appointment_as_done");
    const formState = props.State.FormState.IsLoading ? "disabled" : "enabled";
    if (props.State.Reminder.IsConfirmed) {
        return reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems = [createElement(InformationAlert, {
            Label: t("reminder_dialog.mark_as_not_done_information"),
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
    }
    else {
        return reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "gap-4"])], (elems_7 = toList(delay(() => append(singleton_1(createElement(TextValue, {
            FontWeight: "normal",
            TestId: "",
            Text: labelText,
        })), delay(() => append(isCreateNextReminderCheckboxVisible ? append(singleton_1(Checkbox({
            ComponentState: formState,
            IsChecked: props.State.Dto.CreateNewDate,
            Label: t("reminder_dialog.normal_reminder"),
            OnCheck: (value_4) => {
                props.Dispatch(new Msg(2, [value_4]));
            },
            TestId: "",
        })), delay(() => singleton_1(createElement(InformationAlert, {
            Label: t("reminder_dialog.create_new_reminder_info"),
        })))) : singleton_1(defaultOf_1()), delay(() => {
            let elems_1;
            return !props.State.Reminder.IsConfirmed ? append(props.State.Dto.SetLastInspectionDate ? singleton_1(reactElement("div", createObj(singleton((elems_1 = [createElement(DatePicker, {
                ComponentState: formState,
                IsClearable: true,
                Label: t("reminder_dialog.check_date"),
                OnChange: (newDate) => {
                    props.Dispatch(new Msg(1, [newDate]));
                },
                TestId: "tool-add-reminder-dialog-check-date-test-id",
                Value: unwrap(props.State.Dto.LastInspectionDate),
            })], ["children", reactApi.Children.toArray(Array.from(elems_1))]))))) : singleton_1(defaultOf_1()), delay(() => append(singleton_1(createElement(TextArea, {
                ComponentState: formState,
                Label: t("general.comment"),
                OnChange: (value_7) => {
                    props.Dispatch(new Msg(3, [value_7]));
                },
                TestId: "tool-add-reminder-dialog-comment-test-id",
                Value: props.State.Dto.ConfirmationComment,
            })), delay(() => {
                let elems_5;
                return !props.State.Reminder.IsConfirmed ? append(singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", toList(delay(() => append(singleton_1("flex"), delay(() => append(singleton_1("flex-col"), delay(() => append(singleton_1("justify-center"), delay(() => append(singleton_1("items-center"), delay(() => append(singleton_1("mt-4"), delay(() => append(singleton_1("mb-4"), delay(() => append(singleton_1("rounded-lg"), delay(() => append(singleton_1("border"), delay(() => append(singleton_1("border-dashed"), delay(() => append(singleton_1("border-primary"), delay(() => ((dropData.canDrop && dropData.isOver) ? singleton_1("bg-background") : empty()))))))))))))))))))))))))], ["ref", patternInput_1[1]], (elems_5 = toList(delay(() => {
                    let elems_2, Label_3;
                    return append(singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["mt-4", "mb-4"])], (elems_2 = [createElement(TextButton, (Label_3 = t("file_upload.select_file"), {
                        ComponentState: "enabled",
                        Icon: Upload_File(),
                        Label: Label_3,
                        OnClick: () => {
                            const element = document.getElementById("file-upload");
                            element.click();
                        },
                        TestId: "open-file-explorer-test-id",
                        Variant: "blueButton",
                    }))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))), delay(() => {
                        let elems_4, elems_3;
                        const matchValue_1 = props.SelectedFile;
                        if (matchValue_1 != null) {
                            const selectedFile = matchValue_1;
                            return singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "justify-center", "items-center", "mx-4", "mb-4"])], (elems_4 = [createElement(TextValue, {
                                FontWeight: "small",
                                TestId: "",
                                Text: selectedFile.name,
                            }), reactElement("div", createObj(ofArray([["className", join(" ", ["mt-4"])], (elems_3 = [createElement(TextButton, {
                                ComponentState: "enabled",
                                Label: t("general.remove"),
                                OnClick: () => {
                                    props.OnSelectFile(undefined);
                                },
                                TestId: "close-confirm-reminder-dialog-test-id",
                                Variant: "blueButton",
                            })], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", reactApi.Children.toArray(Array.from(elems_4))])]))));
                        }
                        else {
                            return empty();
                        }
                    }));
                })), ["children", reactApi.Children.toArray(Array.from(elems_5))])])))), delay(() => {
                    let elems_6;
                    return append(singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "justify-center"])], (elems_6 = [reactElement("input", {
                        id: "file-upload",
                        className: join(" ", ["hidden"]),
                        type: "file",
                        onChange: (ev) => {
                            const files = ev.target.files;
                            if (!(files == null) && (files.length > 0)) {
                                props.OnSelectFile(files.item(0));
                            }
                        },
                    })], ["children", reactApi.Children.toArray(Array.from(elems_6))])])))), delay(() => append(singleton_1(createElement(InformationAlert, {
                        Label: t("document_reminder_relation.dialog_information"),
                    })), delay(() => {
                        const matchValue_2 = props.State.DocumentValue;
                        if (matchValue_2 == null) {
                            return singleton_1(defaultOf_1());
                        }
                        else {
                            const docValue = matchValue_2;
                            return append(singleton_1(createElement(Input, {
                                ComponentState: formState,
                                Label: t("general.name"),
                                OnChange: (arg) => {
                                    props.Dispatch(new Msg(5, [arg]));
                                },
                                TestId: "",
                                Value: docValue.Name,
                            })), delay(() => append(singleton_1(createElement(Input, {
                                ComponentState: formState,
                                Label: t("general.description"),
                                OnChange: (arg_1) => {
                                    props.Dispatch(new Msg(6, [arg_1]));
                                },
                                TestId: "",
                                Value: docValue.Description,
                            })), delay(() => singleton_1(Checkbox({
                                ComponentState: formState,
                                IsChecked: docValue.IsVisibleForUserRole,
                                Label: t("tool.document_visible_for_user_role"),
                                OnCheck: (_arg_2) => {
                                    props.Dispatch(new Msg(4, []));
                                },
                                TestId: "",
                            }))))));
                        }
                    }))));
                })) : empty();
            })))) : singleton_1(defaultOf_1());
        })))))), ["children", reactApi.Children.toArray(Array.from(elems_7))])])));
    }
}

export function OpenConfirmReminderDialog(props) {
    let Title;
    const t = useTranslation()[0];
    const patternInput_1 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init(props.SetId, props.SuccessCallback, props.Reminder, props.OnClose), update, (_arg_1, _arg_1_1) => {
    }), undefined, [props.IsOpen]);
    const state_1 = patternInput_1[0];
    const dispatch = patternInput_1[1];
    return createElement(Dialog, (Title = t("general.mark_as_done"), {
        Body: singleton(createElement(DialogBody, {
            Dispatch: dispatch,
            OnSelectFile: (value) => {
                dispatch(new Msg(7, [value]));
            },
            SelectedFile: unwrap(state_1.SelectedFile),
            State: state_1,
        })),
        Controls: toList(delay(() => append(singleton_1(createElement(TextButton, {
            ComponentState: "enabled",
            Label: t("general.cancel"),
            OnClick: props.OnClose,
            TestId: "close-confirm-reminder-dialog-test-id",
            Variant: "blueButton",
        })), delay(() => (!state_1.Reminder.IsConfirmed ? singleton_1(createElement(TextButton, {
            ComponentState: state_1.FormState.IsLoading ? "disabled" : "enabled",
            Label: t("general.mark_as_done"),
            OnClick: () => {
                dispatch(new Msg(8, []));
            },
            TestId: "save-confirm-dialog-test-id",
            Variant: "blueButton",
        })) : empty()))))),
        IsOpen: props.IsOpen,
        OnClose: props.OnClose,
        Title: Title,
    }));
}

